import { Component, OnInit, Input } from '@angular/core';
import {ExcTranslation} from 'exc-core';
import {DefaultSettingsService} from '../../../default-settings-service.service';
import {ExcSigninService} from 'exc-signin';

@Component({
  selector: 'app-excon-client-waffle',
  templateUrl: './excon-client-waffle.component.html',
  styles: []
})
export class ExconClientWaffleComponent extends ExcTranslation implements OnInit {
  @Input('Client') Client;
  constructor(private excDss: DefaultSettingsService, private excSec: ExcSigninService) {
    super();
  }
  ngOnInit() {
  }
  textProcess (text) {

    const re = /\,/gi;
    return  text.replace(re, ', ');
  }
}
